import { Switch, Tooltip, useNotifications } from '@sequencehq/core-components'

import { useAtom, useAtomValue } from 'jotai'
import {
  invoiceCustomerIdAtom,
  invoiceIdAtom
} from 'Invoices/atoms/invoiceEditing.atom'
import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { usePaymentProviderForInvoice } from 'Invoices/hooks/usePaymentProviderForInvoice'
import { EXCLUSIVE_PAYMENT_PROVIDER_MESSAGE } from 'Integrations/index'
import { isPostInvoiceSettingsPendingAtom } from './paymentSettings.atoms'

export const StripePaymentSettingsSwitch = () => {
  const { displayPromiseNotification } = useNotifications()
  const [invoiceSettingsPending, setInvoiceSettingsPending] = useAtom(
    isPostInvoiceSettingsPendingAtom
  )

  const { mutateAsync: createPaymentSettings, isPending: createIsPending } =
    useMutation(dashboard20240730Client.postInvoiceSettings, {
      onMutate: () => {
        setInvoiceSettingsPending(true)
      },
      onSettled: () => {
        setInvoiceSettingsPending(false)
      }
    })

  const paymentProvider = usePaymentProviderForInvoice()
  const invoiceId = useAtomValue(invoiceIdAtom)
  const customerId = useAtomValue(invoiceCustomerIdAtom)

  const isEnabled = paymentProvider === 'STRIPE'
  const otherProviderActive =
    paymentProvider !== 'NONE' && paymentProvider !== 'STRIPE'

  const updateInvoiceSettings = async (isStripePaymentSelected: boolean) => {
    await displayPromiseNotification(
      createPaymentSettings({
        invoiceId: invoiceId ?? '',
        customerId,
        paymentProvider: isStripePaymentSelected ? 'STRIPE' : 'NONE'
      }),
      {
        loading: 'Updating Stripe settings...',
        success: 'Invoice Stripe settings updated',
        error: 'Could not update invoice Stripe settings'
      }
    )
  }

  return (
    <Tooltip
      label={EXCLUSIVE_PAYMENT_PROVIDER_MESSAGE}
      isDisabled={!otherProviderActive}
    >
      <Switch
        data-testid="invoiceTerms.stripeSwitch"
        size="md"
        checked={isEnabled}
        onChange={value => void updateInvoiceSettings(value)}
        disabled={
          isEnabled ||
          otherProviderActive ||
          createIsPending ||
          invoiceSettingsPending
        }
      />
    </Tooltip>
  )
}
